import Button from '@material-ui/core/Button';
import { ErrorPanel } from './ErrorPanel';
import { makeStyles } from '@material-ui/core/styles';
import { ReviewState } from '@backstage/plugin-scaffolder-react/alpha';
import { ReviewStepProps } from '@backstage/plugin-scaffolder-react';
import { useValidations } from './useValidations';

import { Progress, Table, TableColumn } from '@backstage/core-components';

const columns: TableColumn[] = [
  {
    title: 'Error',
    render: (row: any): any => {
      return `❌ ${row.error}`;
    },
    sorting: false,
  },
  {
    title: 'Details',
    field: 'details',
    sorting: false,
  },
  {
    title: 'Fix',
    field: 'fix',
    sorting: false,
  },
];

const useStyles = makeStyles(
  theme => ({
    backButton: {
      marginRight: theme.spacing(1),
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'right',
      marginTop: theme.spacing(2),
    },
  }),
  { name: 'ReviewStep' },
);

export const ReviewStep = (props: ReviewStepProps) => {
  const styles = useStyles();
  const { value, loading, error } = useValidations({
    formData: props.formData,
  });

  if (error) {
    return <ErrorPanel error={error} handleBack={props.handleBack} />;
  }

  if (loading) {
    return <Progress />;
  }

  if (value) {
    const ifAnyValidationFailed = value.filter(
      validation => validation.result === 'failed',
    );
    if (ifAnyValidationFailed.length) {
      return (
        <>
          <Table
            data={ifAnyValidationFailed}
            columns={columns}
            options={{
              toolbar: false,
              search: false,
              paging: false,
              padding: 'dense',
            }}
          />

          <div className={styles.footer}>
            <Button
              onClick={props.handleBack}
              className={styles.backButton}
              color="primary"
              variant="contained"
            >
              Back
            </Button>
          </div>
        </>
      );
    }
  }

  return (
    <>
      <ReviewState
        formState={props.formData}
        schemas={props.steps.map(step => ({ ...step, title: '' }))}
      />
      <div className={styles.footer}>
        <Button onClick={props.handleBack} className={styles.backButton}>
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={props.handleCreate}
        >
          Create
        </Button>
      </div>
    </>
  );
};
